


























// import wx from 'weixin-js-sdk'
import { Component, Vue, Inject } from "vue-property-decorator";
import TitleHeader from "@/components/header.vue";
import { orderPlace } from "@/req/pay";
import payModal from "./payModal.vue";
import Burying from "@/utils/Buryingpoint"

@Component({
  components: {
    TitleHeader,
    payModal
  },
})
export default class Home extends Vue {
  @Inject() public readonly switchOver;
  public payList = [
    { id: 11, uid: 3, name: "支付宝", img: require("@/assets/icons/Alipay.png") },
    { id: 2, uid: 4, name: "微信", img: require("@/assets/icons/WeChat.png") },
    { id: 16, uid: 4, name: "微信", img: require("@/assets/icons/WeChat.png") },
  ];
  public state = false;
  public obj: any = {};
  public mounted() {
    if (this.$store.state.user.weix === true) {
      this.payList = this.payList.filter((item) => item.id !== 2)
      this.payList.splice(0,1)
      console.log("YASpayWay")
    }else{
      this.payList = this.payList.filter((item) => item.id !== 16)
      console.log("NOpayWay")
    }
    this.obj = this.$route.query;
    this.pushHistory();
    window.addEventListener("popstate", this.handlePopstate, false);
    window.addEventListener("visibilitychange", this.handleVisible);
  }
  public handleVisible(e) {
    if (e.target.hidden) {
      this.handlePopstate();
      this.$store.dispatch('user/authRouter', false);
    }
  }
  public pushHistory() {
    const iframe: any = document.createElement("iframe");
    iframe.id = "payUrlIframe";
    iframe.frameBorder = "0";
    iframe.width = "100%";
    iframe.height = "100%";
    iframe.scrolling = "no";
    iframe.style.display = "none";
    iframe.style.zIndex = '9999';
    iframe.sandbox = "allow-modals allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation allow-top-navigation-by-user-activation";
    document.body.appendChild(iframe);
    const state = {
      title: "title",
      url: "#",
    };
    window.history.pushState(state, "title", "#");
  }
  public handlePopstate() {
    const payUrl = (window as any).parent.document.getElementById(
      "payUrlIframe"
    );
    this.$store.dispatch('user/authRouter', false);
    if (!payUrl) {
      return false;
    }
    payUrl.parentNode.removeChild(payUrl);
  }
  public destroyed() {
    window.removeEventListener("popstate", this.handlePopstate);
    window.removeEventListener("visibilitychange", this.handleVisible);
    this.handlePopstate();
  }
  public async getPay(payWay, payUid) {
    this.state = true;
    const u = navigator.userAgent;
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    const obj: any = {
      uid: this.$store.state.user.info.uid,
      role_id: this.obj.role_id,
      role_name: this.obj.role_name,
      trade_no: this.obj.trade_no,
      server_id: this.obj.server_id,
      price: this.obj.price,
      pay_way: isAndroid || isiOS ? payWay : payUid,
      device: isiOS ? "ios" : "",
      payplatform2cp: this.obj.payplatform2cp,
      props_name: this.obj.props_name,
      server_name: this.obj.server_name,
      job_id: this.obj.job_id || '0',
      job_name: this.obj.job_name || '无',
      role_level: this.obj.role_level || '0',
      openid: sessionStorage.getItem("openid") || '',
      is_box: sessionStorage.getItem("is_box") || '',
      _device_info: Burying.Escalation()
    };
    // obj.jl_report = JSON.stringify({adid:sessionStorage.getItem('adid'), creativeid:sessionStorage.getItem('creativeid'), creativetype:sessionStorage.getItem('creativetype'), clickid:sessionStorage.getItem('clickid'),type: 'h5'})
    if( this.$store.state.user.weix === true ){
      wx.miniProgram.getEnv((res)=>{
        if (res.miniprogram) {
          console.log('在小程序里');
          obj.pay_way = '16'
        } else {
          console.log('不在小程序里');
          obj.pay_way = '15'
        }
      })
    }
    let res = await orderPlace(obj);
    const payUrl = (window as any).parent.document.getElementById(
      "payUrlIframe"
    );
    if (this.$store.state.user.weix === true) {
      wx.miniProgram.getEnv((data)=>{
        if (data.miniprogram) {
          wx.miniProgram.getEnv(function (){
            console.log('小程序')
            // wx.miniProgram.navigateBack({delta: 1})
            wx.miniProgram.postMessage({
              data:{ message:data }
            })
          })
          wx.miniProgram.redirectTo({
            url:'../pay/pay'
          })
        } else {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
              "appId":res.data.pay_data.appId,     //公众号ID，由商户传入
              "timeStamp":res.data.pay_data.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":res.data.pay_data.nonceStr, //随机串
              "package":res.data.pay_data.package,
              "signType":"MD5",         //微信签名方式：
              "paySign":res.data.pay_data.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ){
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                console.log('调起公众号支付')
                console.log(res)
              }
            });
        }
      })

    } else {
      console.log('微信外调起公众号支付');
      console.log(this.$store.state.user.weix);
      sessionStorage.removeItem("gameid2")
    }
    if (res.code === 200 && isAndroid) {
      payUrl.style.display = "block";
      if (payWay === 11) {
        payUrl.src = res.data.pay_data;
      } else if (payWay === 2) {
        window.open(res.data.mweb_url);
      }
    } else if (res.code === 200 && isiOS) {
      if (payWay === 11) {
        debugger
        window.location.href = res.data.pay_data;
      } else if (payWay === 2) {
        window.location.href = res.data.mweb_url;
      }
    } else if (res.code === 200 && !isAndroid && !isiOS) {
      const $payModal: any = this.$refs.payModal;
      $payModal.show(res.data);
    }
    this.state = false;
  }
}
